<template>
  <div
    ref="div"
    class="popover-toggle-wrapper"
    @click="$emit('update:showPopover', !showPopover)"
  >
  <slot name="toggle" />
  <div class="popover-content-panel" v-if="showPopover">
    <slot name="content" />
  </div>
  </div>
</template>

<script setup>
import { ref } from "vue"
import { onClickOutside } from "@vueuse/core"

defineProps({
  showPopover: {
    type: Boolean,
    required: true
  },
  hover: {
    type: Boolean,
    required: false
  }
})

const emit = defineEmits(["update:showPopover"])

const div = ref(null)

onClickOutside(div, () => {
  emit("update:showPopover", false)
})
</script>
<style scoped>
.popover-toggle-wrapper {
  border-radius: 10px;
  position: relative;
  padding: 0.5em;
}
.popover-content-panel {
  box-shadow: 1px 1px 1px 2px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 0.25em;
  position: absolute;
  margin-top: 1em;
  padding: 1em;
  right: 0;
  z-index: 100;
  align-items: center;
  align-content: center;
}

.popover-toggle-wrapper:hover {
  background-color: rgb(233, 233, 233);
}
</style>
